import { render, staticRenderFns } from "./publicitySubDetail.vue?vue&type=template&id=23f23f20"
import script from "./publicitySubDetail.vue?vue&type=script&lang=js"
export * from "./publicitySubDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports